import React from "react";
import { Link } from "react-router-dom";
import {
  HeaderStyled,
  NameWrapper,
  Nav,
  NavWrapper,
} from "../Styled/Header.styled";

export interface HeaderProps {
  type?: string;
  name?: string;
  dir?: string;
  redir?: string;
}

const Header = ({ type, name, dir, redir }: HeaderProps) => {
  return (
    <HeaderStyled>
      <Link to="/">
        <NameWrapper>
          <div>
            <h1>ondřej andrešič</h1>
          </div>
          <div>
            <p>cinematographer</p>
          </div>
        </NameWrapper>
      </Link>
      <NavWrapper>
        <Link to={`/${redir}`}>
          {type ? (
            <Nav>
              <h1>{type}</h1>
            </Nav>
          ) : (
            <></>
          )}
        </Link>
      </NavWrapper>
    </HeaderStyled>
  );
};

export default Header;
